import Work1 from '../../assets/1.png';
import Work2 from '../../assets/Netflix logo.jpg';
import Work3 from '../../assets/Spotify logo.jpg';
import Work4 from '../../assets/bookyourshow.png'

export const projectsData = [

  {
    id: 1,
    image: Work1,
    title: "  Food Delivery Web",
    category: "web",
    link: 'https://fooddelivery-frontend-eday.onrender.com'
  },
  {
    id: 2,
    image: Work2,
    title: "Netflix Clone",
    category: "web",
    link: 'https://netcineclone.netlify.app'
  },
  {
    id: 3,
    image: Work3,
    title: "Spotify Clone",
    category: "web",
    link: 'https://spotifyclone-frontend-ppdd.onrender.com'
  },
    {
    id: 4,
    image: Work4,
    title: "Book Your Show",
    category: "web",
    link: 'https://bookyourshowweb.vercel.app'
  },
];

export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'web',
  },

  {
    name: 'other',
  },
];